var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWindowsMaximize = function SvgWindowsMaximize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1801 -3099 10 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "windows_maximize_svg__a",
    d: "M-1801-3099v10h10v-10Zm9.2 9.2h-8.3v-8.3h8.3Z"
  })));
};
export default SvgWindowsMaximize;